const SugerirProdutoAgregadoController = ControllerBase.extend({
    name: 'SugerirProdutoAgregadoController',
    framework: 'knockout',

    dataBreadcrumb: new DataBreadcrumb({
        columns: [
            { title: 'Produto', prop: 'CodigoProduto' },
            { title: 'Descricao', prop: 'DescricaoProduto' }
        ],

        getData: function () {
            
            return this.toJS(this.itemOrcamento);
        },

        //getData: function () {
        //    var modelAux = this.itemOrcamento.toJSON();

        //    if (modelAux.IdentificadorOrcamento) {
        //        modelAux.CodigoProduto = modelAux.CodigoProdutoExibicao;
        //    }

        //    return modelAux;
        //}, 
    }),


    ajax: function () {

        return {
            url: "/Produto/_SugerirAgregado",
            type: "get",
        }
    },

    newModel: function () {

        return {
            ProdutosAgregadosSugeridos: [],
            totaldePedidosAnalisados: 0
        };

    },

    initialize: function () {
        this.setModel(this.newModel());
        var self = this;

        setTimeout(function () {
            self.listarProdutoAgregado();
        });
    },

    renderizado: function () {
        $("#menu-sub-consulta-produtos").hide();
        if (this.modoInclusao !== undefined && !this.modoInclusao) {
            $("#adicionarAgregadoSugerido").hide();
        }
    },

    antesBinding: function () {
    },

    listarProdutoAgregado: function (model, e, pagina) {


            //temos que criar esta variavel para passar para o metodo global.ajax fazer uma transferencia de controle para  o metodo.
            //todo argumento ou variavel que deseja ter acesso no global.ajax temos que declaarar uma variavel e transmitir para ele.
            var self = this;

            var filtros = {
                CodigoProdutoAnalisado:  this.itemOrcamento.get("Codigo")
            };


            global.ajax({
                url: "/Produto/ListarProdutoAgregado",
                type: 'post',
                data: global.toJSONString({
                    filtros: filtros
                }),
                success: function (data) {

                    if (data.length === 0 || data.HasErrors) {
                        self.model.ProdutosAgregadosSugeridos.removeAll();
                        global.showWarnMessage('Nenhum registro encontrado.');
                        return;
                    }

                    data.forEach(function (item) {
                        item.selecionado = false;
                    });

                    var m = ko.mapping.fromJS(data);
                    self.model.ProdutosAgregadosSugeridos(m());

                    self.model.totaldePedidosAnalisados(self.model.ProdutosAgregadosSugeridos()[0].TotaldePedidosAnalisados());
                }
            });

    },

    selecionarProdutoAgregadoSugerido: function (model)
    {
        model.selecionado(!model.selecionado());
    },

    adicionarAgregadoSugerido: function () {

        var self = this;

        var itens = ko.utils.arrayFilter(self.model.ProdutosAgregadosSugeridos(), function (item) {
            return item.selecionado() === true;
        });

        if (itens.length === 0) {
            global.showErrorMessage('Por favor, selecione os produtos a serem adicionados.');
            return;
        }
        var produto = [];

        // pensei em alterar o CONTRACT para retornar codigo ao inves de CodigoProdutoSugerido ao inves de colocar este loop, porém, acabaria que o push
        // seria da classe inteira desnecessariamente pois o que interese para acrescentar o produtosugerido seria apenas o codigo do produto, as demais informacoes contidas no 
        // contrato, nao sao esperadas pelo servico "adicionarItens"
        itens.forEach(function (item) {
            produto.push({ codigo: item.CodigoProdutoSugerido().trim() });;
        });

        //this.orcamento.adicionarItens(produto, self.adicionarProdutosCallback)
        if (this.adicionarProdutosCallback) {
            this.adicionarProdutosCallback(produto, "adicionarAgregadoSugerido");
        }
    }
})

window.SugerirProdutoAgregadoController = SugerirProdutoAgregadoController

export {
    SugerirProdutoAgregadoController
}